import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useAdminContext } from "../libs/adminLib.js";

export default function AdminRoute({ children, ...rest }) {
  const { pathname, search } = useLocation();
  const { isAdmin } = useAdminContext();
  return (
    <Route {...rest}>
      {isAdmin ? (
        children
      ) : (
        <Redirect to={
          `/?redirect=${pathname}${search}`
        } />
      )}
    </Route>
  );
}